// extracted by mini-css-extract-plugin
export default {"aboutSection":"Aside_aboutSection__luJU8","languagesSection":"Aside_languagesSection__in25B","skillsSection":"Aside_skillsSection__jGMp1"};